import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	static targets = ['row'];

	connect() {
		this.rowTargets.forEach((row) => {
			row.addEventListener('click', () => {
				const href = row.dataset.href;
				if (href) {
					window.location.href = href;
				}
			});
		});
	}
}
